import { createSelector } from "@reduxjs/toolkit";

import { AppState } from "@/redux/store";

const getDispensary = (state: AppState) => state.dispensary;

export const getCurrentDeliveryZone = createSelector(
  [getDispensary],
  (dispensary) => {
    return dispensary.deliveryZone;
  },
);

export const getHasFollowed = createSelector(
  [getDispensary],
  (dispensary) => dispensary.followed,
);
